module.exports = __webpack_public_path__ + "static/img/1.0b6e6bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/eng/1.png
// module id = 87iZ
// module chunks = 0